import { setupGlobalEvents } from './globalEvents';
import handlePPPRedirects from './handlePPPRedirects';
import loggingAndAnalyticsSetup from './loggingAndAnalyticsSetup';
import loadPolyfills from 'config/polyfills';
import axiosSetup from './axiosSetup';
// import setupGoogleAnalytics from './setupGoogleAnalytics';

export default function setup(history) {
  setupGlobalEvents();
  handlePPPRedirects();
  loggingAndAnalyticsSetup(history);
  loadPolyfills();
  axiosSetup();
  // setupGoogleAnalytics();
}
